/* Follow Dawn's already-rendered selected-variant status. No second product
 * request, inventory inference, or alteration of its price/add-to-bag logic. */
(() => {
  if (customElements.get('bd-product-media-promotions')) return;
  customElements.define('bd-product-media-promotions', class extends HTMLElement {
    connectedCallback() {
      if (this.unsubscribeVariant) return;
      this.productInfo = this.closest('product-info');
      if (!this.productInfo || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      this.unsubscribeOptions = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
        if (this.productInfo.contains(data?.event?.target)) this.hidden = true;
      });
      this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (String(data?.sectionId) !== String(this.productInfo.dataset.section)) return;
        const selectedId = this.productInfo.querySelector('product-form input[name="id"]')?.value;
        if (selectedId !== undefined && String(selectedId) !== String(data?.variant?.id)) return;
        const updated = data?.html?.getElementById(this.id);
        if (!updated || !data?.variant) {
          this.hidden = true;
          return;
        }
        this.innerHTML = updated.innerHTML;
        this.hidden = false;
      });
    }
    disconnectedCallback() {
      this.unsubscribeOptions?.();
      this.unsubscribeVariant?.();
      this.unsubscribeOptions = undefined;
      this.unsubscribeVariant = undefined;
    }
  });
})();
